import {DOCUMENT,isPlatformBrowser} from '@angular/common';
import {InjectionToken,PLATFORM_ID,inject} from '@angular/core';
import {environment} from '../../../environments/environment';
import {loadScript} from '../load-script';
import {ConsentService} from '../consent/consent.service';

const PIXEL_SRC='https://connect.facebook.net/en_US/fbevents.js';

export interface Fbq{(...args:unknown[]):void;queue?:unknown[];callMethod?:(...args:unknown[])=>void;loaded?:boolean;version?:string;push?:unknown}

export const META_PIXEL=new InjectionToken<()=>Promise<Fbq|null>>('facebook.pixel',{
	providedIn:'root',
	factory:()=>{
		const isBrowser=isPlatformBrowser(inject(PLATFORM_ID));
		const document=inject(DOCUMENT);
		const consent=inject(ConsentService);
		let pending:Promise<Fbq|null>|null=null;
		return ():Promise<Fbq|null>=>{
			if(!isBrowser||!environment.facebook.pixelId||!consent.marketing()){
				return Promise.resolve(null);
			}
			pending??=(():Promise<Fbq|null>=>{
				const window=document.defaultView;
				if(!window) return Promise.resolve(null);
				const fbq:Fbq=window.fbq ?? Object.assign(
					function(...args:unknown[]):void{
						const self=window.fbq as Fbq;
						if(self.callMethod) self.callMethod(...args);
						else self.queue?.push(args);
					} as Fbq,
					{queue:[] as unknown[],loaded:true,version:'2.0'}
				);
				fbq.push=fbq;
				window.fbq??=fbq;
				window._fbq??=fbq;
				fbq('init',environment.facebook.pixelId);
				return loadScript(document,PIXEL_SRC).then(():Fbq=>fbq);
			})();
			return pending;
		};
	}
});
